module.exports = __webpack_public_path__ + "static/media/fa-thin-100.29a80a91.woff2";